// 图片上传地址 不需要带任何参数
export const uploadUrl = '/bp/api/upload';